import { type Prisma } from '@prisma/client';
import { gtmCustomEvent } from '#common/utils/tracking/google-analytics.tsx';

export function trackMediumSelection(
    selected: string[],
    availableUses: (Prisma.AvailableUseGetPayload<{ include: { medium: true } }>)[],
) {
    queueMicrotask(() => {
        gtmCustomEvent('medium_selection', {
            medium_ids: selected.join(','),
            count: selected.length,
            mediums: availableUses.filter(mu => selected.includes(mu.id)).map(mu => mu.medium.name).join(',')
        });
    });
}

export function trackClickSampleVoice() {
    queueMicrotask(() => {
        gtmCustomEvent('click_sample_voice', {});
    });
}

export function trackClickGenerateVoice(characters: number) {
    queueMicrotask(() => {
        gtmCustomEvent('click_generate_voice', {
            characters: characters
        });
    });
}

export function trackClickVoiceSettings() {
    queueMicrotask(() => {
        gtmCustomEvent('click_voice_settings', {});
    });
}

export function trackCheckoutTotalSum(originalPrice: number, discountedPrice: number, appliedCoupon?: string) {
    queueMicrotask(() => {
        gtmCustomEvent('checkout_total_sum', {
            original_price: originalPrice,
            discounted_price: discountedPrice,
            applied_coupon: appliedCoupon
        });
    });
}

export function trackVoiceGenerations(recordings: number, totalVersions: number) {
    queueMicrotask(() => {
        gtmCustomEvent('voice_generations', {
            recordings: recordings,
            total_versions: totalVersions
        });
    });
}

export function trackClickCheckout(originalPrice: number, discountedPrice: number, appliedCoupon?: string) {
    gtmCustomEvent('click_checkout', {
        original_price: originalPrice,
        discounted_price: discountedPrice,
        applied_coupon: appliedCoupon
    });
}

export function trackGenerationJobId(voiceGenerationJobId: string) {
    gtmCustomEvent('generation_job_id', {
        job_id: voiceGenerationJobId
    });
}
